export default __webpack_public_path__ + "static/media/f_photogallery.f6ef1653.svg";